import React, { useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import DOMPurify from 'dompurify';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export default function CreateAccount() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_BASE_URL;
    // Regular expression for strong password
    const strongPasswordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/;
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [isUsernameValid, setIsUsernameValid] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({
        password: '',
        username: '',
        email: '',
        otp_code: '',
    });
    const [otp, setOtp] = useState(['', '', '', '']);
    const [step, setStep] = useState(1);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'otp_code') {
            if (value.length > 4) return;    // Enforce a maximum length of 4
        }
        const sanitizedValue = DOMPurify.sanitize(value);
        /*  if (value.length === 1 && index < 3) {
             e.target.form[`otp_digit_${index + 1}`]?.focus();
         } */
        setFormData({
            ...formData,
            [name]: sanitizedValue,
        });

        // Check password validity on change
        if (name === 'password') {
            setIsPasswordValid(strongPasswordRegex.test(value));
        }
        if (name === 'username') {
            setIsUsernameValid(value.length >= 5);
        }
    };

    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate password before submitting
        if (!isPasswordValid) {
            toast.error('Password should be at least 8 characters long and contain at least one digit, one uppercase letter, and one special character.');
            return;
        }

        if (!isUsernameValid) {
            toast.error('Username should be at least 5 characters long.');
            return;
        }

        setIsLoading(true);

        try {
            const sanitizedUsername = DOMPurify.sanitize(formData.email, { SAFE_FOR_TEMPLATES: true });
            const sanitizedPassword = DOMPurify.sanitize(formData.password, { SAFE_FOR_TEMPLATES: true });

            const response = await fetch(`${baseURL}/user-register`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    account_type: 5,
                    password: sanitizedPassword,
                    email: sanitizedUsername,
                    user_source: "Web",
                    phonenumber: "",
                    user_role: "",
                    languages: [],
                    genre_ids: [],
                    readingpreferenceid: 0,
                    readingtimeid: 0,
                    stateid: 0,
                    districtid: 0,
                    zipcode: "",
                    agegroupid: 0,
                    mentorid: 0,
                    mentor_name: "",
                    fcm_token: "",
                    genderid: 0,
                    dob: "2025-01-20"
                }),
            });

            const result = await response.json();
            console.log('Response body:', result);
            if (response.ok) {
                if (result.status_code === 200) {
                    const { access_token, refresh_token, user } = result;

                    // Store tokens and user ID in localStorage
                    localStorage.setItem('authToken', access_token);
                    localStorage.setItem('refresh_token', refresh_token);
                    localStorage.setItem('userid', user[0].userid);

                    login(); // Call the login function from AuthContext
                    navigate('/edit_profile');
                }
                else {
                    toast.error(result.message);
                }

            }
            else {
                toast.error(result.message);
            }
        } catch (error) {
            setErrorMessage('An error occurred during registration.');
        }
        finally {
            setIsLoading(false);
        }
    };

    const handleSendOTP = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const sanitizedEmail = DOMPurify.sanitize(formData.email, { SAFE_FOR_TEMPLATES: true });

            const response = await fetch(`${baseURL}/send-otp`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: sanitizedEmail
                }),
            });

            const result = await response.json();
            console.log('Response body:', result);
            if (response.ok) {
                if (result.status_code === 200) {
                    toast.success(result.message);
                    setStep(2);
                }
                else if (result.status_code === 400) {
                    toast.error(result.message);
                    setStep(1);
                }
            } else {
                toast.error(result.message);
            }

        } catch (error) {
            setErrorMessage('An error occurred during registration.');
        }
        finally {
            setIsLoading(false);
        }

    }


    const handleOtpChange = (value, index) => {
        if (!/^\d*$/.test(value)) return; // Allow only numeric values
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Automatically focus next input if a digit is entered
        if (value && index < 3) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };

    const handleVarifyEmail = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const sanitizedEmail = DOMPurify.sanitize(formData.email, { SAFE_FOR_TEMPLATES: true });
            //   const sanitizedOTP = DOMPurify.sanitize(formData.otp_code, { SAFE_FOR_TEMPLATES: true });

            const sanitizedOTP = DOMPurify.sanitize(otp.join(''), { SAFE_FOR_TEMPLATES: true });


            const response = await fetch(`${baseURL}/verify-otp`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: sanitizedEmail,
                    otp_code: sanitizedOTP
                }),
            });

            const result = await response.json();
            console.log('Response body:', result);
            if (response.ok) {
                if (result.status_code === 200) {
                    toast.success(result.message);
                    setStep(3);
                }
                else if (result.status_code === 400) {
                    toast.error(result.message);
                    setStep(2);
                }


            }
            else {
                toast.error(result.message || 'Registration Failed');
            }
        } catch (error) {
            setErrorMessage('An error occurred during registration.');
        }
        finally {
            setIsLoading(false);
        }

    }
    return (
        <>

            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                theme="dark"
            />

            <section className="user-form-part">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-10 col-md-8 col-xl-5">
                            <div className="user-form-card">

                                <div className="user-form-group">

                                    {step === 3 && (

                                        <form onSubmit={handleSubmit} className="user-form">
                                            <div className="user-form-title">
                                                <h2>Create Your Account</h2>
                                                <p>Secure Your Account: Set a Password</p>
                                            </div>
                                            <div className="form-group">
                                                <input type="email" className="form-control user-email" id="username" name="email" value={formData.email} onChange={handleChange} placeholder='Enter Email' required readOnly />
                                            </div>
                                            <div className="form-group">
                                                <input type={showPassword ? 'text' : 'password'} id="password" className="form-control" name="password" onChange={handleChange} placeholder='Enter Password' required />
                                                <span className={`far fa-fw ${showPassword ? 'fa-eye' : 'fa-eye-slash'} eye-icon toggle-password`} onClick={togglePasswordVisibility}></span>
                                            </div>
                                            {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
                                            <div className="col-md-12 text-center">
                                                <button
                                                    type="submit"
                                                    className='btn-6 view-all-btnn mt-3 text-capitalize'
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? <div className="spinner-border" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div> : 'Create a New Account'}
                                                </button>
                                            </div>
                                        </form>
                                    )}

                                    {step === 1 && (
                                        <form onSubmit={handleSendOTP} className="user-form ">
                                            <div className="user-form-title">
                                                <h2>Create Your Account</h2>
                                                <p>Verify Your Email Address</p>
                                            </div>
                                            <div className="form-group">
                                                <input type="email" className="form-control user-email" id="email" name="email" onChange={handleChange} placeholder='Enter Email' required />
                                            </div>
                                            {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}

                                            <div className="col-md-12 text-center">
                                                <button
                                                    type="submit"
                                                    className='btn-6 view-all-btnn mt-3 text-capitalize'
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? <div className="spinner-border" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div> : 'Verify Email'}
                                                </button>
                                            </div>
                                        </form>
                                    )}

                                    {step === 2 && (
                                        <form onSubmit={handleVarifyEmail} className="user-form">
                                            <div className="user-form-title">
                                                <h2>Create Your Account</h2>
                                                <p>OTP Verification</p>
                                            </div>
                                            <div>
                                                <span>OTP has been sent to </span>
                                            </div>
                                            <div className="form-group d-flex">
                                                <input type="email" className="form-control user-email vefify-email-box" id="email" name="email" value={formData.email} onChange={handleChange} placeholder='Enter Email' required readOnly />
                                                <a href='/create_account'>Edit</a>
                                            </div>

                                            {/* <div className="otp-input-fields">
                                                <input type="text" className="form-control user-email" id="otp_code" name="otp_code" onChange={handleChange} maxLength="4" placeholder='Enter OTP' required />

                                            </div> */}
                                            <div className="form-group otp-boxes">
                                                {otp.map((digit, index) => (
                                                    <input
                                                        key={index}
                                                        id={`otp-${index}`}
                                                        type="text"
                                                        maxLength="1"
                                                        value={digit}
                                                        onChange={(e) => handleOtpChange(e.target.value, index)}
                                                        onFocus={(e) => e.target.select()}
                                                        required
                                                    />
                                                ))}
                                            </div>


                                            {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
                                            <div className="col-md-12 text-center">
                                                <button
                                                    type="submit"
                                                    className='btn-6 view-all-btnn mt-3 text-capitalize'
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? <div className="spinner-border" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div> : 'Verify Now'}
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                            <div className="user-form-remind">
                                <p>Already have an account?<NavLink to="/login">Sign In</NavLink></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
